export default __webpack_public_path__ + "static/sephora-922efcf5b1b703d5a04fa7c3b4aa1d36.svg";